var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"changeLog"},[_vm._l((_vm.versionIds),function(id){return _c('ChangeLogVersion',{key:id,attrs:{"id":id}})}),_vm._v(" "),_c('div',{staticClass:"showMore"},[(!_vm.singleVersion)?_c('span',{staticClass:"showMoreLink",on:{"click":_vm.showMore}},[_vm._v("\n      Show More\n    ")]):_c('router-link',{attrs:{"to":"/versions"}},[_vm._v("Show All Versions")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1352f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangeLog.vue
// module id = 166
// module chunks = 0